import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户协议', path: '/about#terms' },
    ],
  },
  {
    title: '热门板块',
    links: [
      { label: '网红爆料', path: '/category/all' },
      { label: '明星八卦', path: '/category/all' },
      { label: '吃瓜大赛', path: '/category/all' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '微博', path: '#' },
      { label: '微信公众号', path: '#' },
      { label: '抖音', path: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
            <div>
              <Link to="/" className="font-heading text-2xl text-accent-400 whitespace-nowrap cursor-pointer">
                黑料吃瓜网
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
                全网最新网红黑料与娱乐八卦资讯平台。
                <br />
                第一时间捕捉劲爆内容，
                <br />
                吃瓜不迷路，入口永在线。
              </p>
            </div>

            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-foreground-200 uppercase tracking-wider mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.path.startsWith('/') ? (
                        <Link
                          to={link.path}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <a
                          href={link.path}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                          rel="nofollow"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t border-secondary-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} 黑料吃瓜网 - 版权所有
              </p>
              <div className="flex items-center gap-6">
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700/50 hover:bg-accent-500/30 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  rel="nofollow"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700/50 hover:bg-accent-500/30 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  rel="nofollow"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700/50 hover:bg-accent-500/30 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  rel="nofollow"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 overflow-hidden">
            <div className="font-heading text-7xl md:text-9xl text-secondary-800/30 select-none tracking-tighter whitespace-nowrap">
              HLCGW
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}